import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FaTimes, FaPlus, FaMinus, FaTrash } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { 
        cartItems, 
        isCartOpen, 
        setIsCartOpen, 
        removeFromCart, 
        incrementItem, 
        decrementItem 
    } = useCart();

    const navigate = useNavigate();

    const totalPrice = cartItems.reduce((sum, item) => sum + item.totalPrice, 0).toFixed(2);

    useEffect(() => {
        if (isCartOpen && window.innerWidth > 768) {
            document.body.style.marginRight = "400px";
        } else {
            document.body.style.marginRight = "0";
        }

        return () => {
            document.body.style.marginRight = "0";
        };
    }, [isCartOpen]);


    return (
        <MainContent $isCartOpen={isCartOpen}>
                

            <CartContainer $isOpen={isCartOpen}>
                <CartHeader>
                    <h3>Handlekurv ({cartItems.length})</h3>
                    <CloseButton onClick={() => setIsCartOpen(false)}>
                        <FaTimes />
                    </CloseButton>
                </CartHeader>

                <CartItems>
                    {cartItems.length === 0 && <p style={{textAlign: "center"}}>Handlekurven er tom</p>}
                    {cartItems.map(item => (
                        <CartItem key={item._id}>
                            <ItemImage src={item.image} alt={item.name} />
                            
                            <ItemDetails>
                                <ItemName>{item.name}</ItemName>
                                
                                <PriceContainer>
                                    {item.totalPrice < item.quantity * item.price ? (
                                        <>
                                            <OriginalPrice>kr {(item.quantity * item.price).toFixed(0)}</OriginalPrice>
                                            <DiscountedPrice $isDiscounted={true}>kr {item.totalPrice?.toFixed(0)}</DiscountedPrice>
                                        </>
                                    ) : (
                                        <DiscountedPrice $isDiscounted={false}>kr {item.totalPrice?.toFixed(0)}</DiscountedPrice>
                                    )}
                                </PriceContainer>

                                <QuantityControl>
                                    <Button onClick={() => decrementItem(item._id)}>
                                        <FaMinus size={12} />
                                    </Button>
                                    
                                    <Quantity>{item.quantity}</Quantity>
                                    
                                    <Button onClick={() => incrementItem(item._id)}>
                                        <FaPlus size={12} />
                                    </Button>
                                </QuantityControl>
                            </ItemDetails>

                            <RemoveButton onClick={() => removeFromCart(item._id)}>
                                <FaTrash size={18}/>
                            </RemoveButton>
                        </CartItem>
                    ))}
                </CartItems>

            <CartFooter>
                <TotalPrice>Delsum: {totalPrice} NOK</TotalPrice>
                <CheckoutButton onClick={() => {navigate("/checkout"); setIsCartOpen(false)}} disabled={cartItems.length === 0}>Gå til betaling</CheckoutButton>
            </CartFooter>
            </CartContainer>
        </MainContent>

    );
};

const MainContent = styled.div`
    transition: margin-right 0.4s ease-in-out;
    margin-right: ${({ $isCartOpen }) => ($isCartOpen ? "400px" : "0")};

    @media (max-width: 768px) {
        margin-right: 0;
    }
`;

const CartContainer = styled.div`
    position: fixed;
    top: 0;
    right: ${({ $isOpen }) => ($isOpen ? "0" : "-100%")};
    width: 400px;
    height: 100vh;
    background: white;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.4s ease-in-out;
    display: flex;
    flex-direction: column;
    z-index: 1000;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const CartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #eee;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
    color: #2d6a4f;
`;

const CartItems = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 1rem;

    scrollbar-width: none;
    -ms-overflow-style: none;
    
    &::-webkit-scrollbar {
        display: none;
    }
`;

const CartItem = styled.div`
    display: flex;
    gap: 1rem;
    padding: 1rem 0;
    border-bottom: 1px solid #eee;
`;

const ItemImage = styled.img`
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
`;

const ItemDetails = styled.div`
    flex: 1;
`;

const ItemName = styled.h4`
    font-size: 1rem;
    margin-bottom: 0.5rem;
    color: #2d6a4f;
`;

const PriceContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;;
`;

const OriginalPrice = styled.span`
    font-size: 0.9rem;
    color: #888;
    text-decoration: line-through;
`;

const DiscountedPrice = styled.span`
    font-size: 1rem;
    color: ${({ $isDiscounted }) => ($isDiscounted ? "#d32f2f" : "inherit")};
    font-weight: ${({ $isDiscounted }) => ($isDiscounted ? "bold" : "inherit")};

`;

const QuantityControl = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const Button = styled.button`
    width: 28px;
    height: 28px;
    border: 1px solid #2d6a4f;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    cursor: pointer;
    color: #2d6a4f;

    
`;

const Quantity = styled.span`
    min-width: 20px;
    text-align: center;
`;

const RemoveButton = styled.button`
    background: none;
    border: none;
    color: #f94144;
    cursor: pointer;
    align-self: center;
    padding: 5px;
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.1);
    }
`;

const CartFooter = styled.div`
    padding: 12px;
    border-top: 1px solid #eee;
`;

const TotalPrice = styled.p`
    font-size: 1.25rem;
    font-weight: bold;
    color: #2d6a4f;
    margin-bottom: 1.5rem;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 1.1rem;
        margin-bottom: 1rem;
    }
`;

const CheckoutButton = styled.button`
    width: 100%;
    padding: 12px 24px;
    background-color: #2d6a4f;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s;

    &:hover {
        background-color: #1b4332;
    }

    &:disabled {
        background: #a0a0a0;
        cursor: not-allowed;
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        padding: 8px 12px;
        font-size: .9rem;
    }
`;

export default Cart;